<div class="main">
    <div class="header">
        <div class="title">{{'HELP_DESK.title' | translate}}</div>
        <div class="sub_title">{{'HELP_DESK.sub_title' | translate}}</div>
    </div>
    <div class="video_sec">
        <div class="left_content">
            <div class="video_menu">
                <input type="text" [(ngModel)]="searchVideo" class="search_video_input" placeholder="Search...">
                <div *ngFor="let item of arr | filter:searchVideo">
                    <div (click)="videochange(item)" class="video_list"> {{item.name +' ?'}}</div>
                </div>
            </div>

        </div>
        <div class="right_content">
            <div class="video_play">
                <div style="
                position: relative;
                padding-bottom: 56.25%;
                height: 0;
                border-radius: 0;
                box-shadow: 0 15px 40px rgba(63,58,79,.3);
                overflow: hidden;
                min-width:320px"><iframe [src]="video_URL" frameborder="0" webkitallowfullscreen mozallowfullscreen
                        allowfullscreen
                        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
            </div>
            <div class="display_text animate-charcter">{{displaytext}}</div>
        </div>
    </div>

</div>